/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect} from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import {Link} from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import {Toaster} from "react-hot-toast";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import CallContext from "../../Context/CallContext";
import EnableCommunication from "../../Components/Settings/CommunicationSettings/EnableCommunication";
import DisableCommunication from "../../Components/Settings/CommunicationSettings/DisableCommunication";
import AddSetting from "../../Components/Settings/CommunicationSettings/AddSetting";
import CommunicationSettingsTable from "../../Components/Common/Settings/CommunicationSettings/CommunicationSettingsTable";

function CommunicationSettingsPage() {

    const {globalCommunicationSettings, getGlobalCommunicationSettings, schoolCommunicationSettings, getSchoolCommunicationSettings, loading} = useContext(CallContext);

    const refreshData = () =>{
        getGlobalCommunicationSettings();
        getSchoolCommunicationSettings();
    }

    useEffect(() => {
        getGlobalCommunicationSettings();
        getSchoolCommunicationSettings();
    }, []);

    const [modal, setModal] = useStateCallback(false);

    const handleEnable=(e,item)=>{
        setModal(false, ()=>setModal(<EnableCommunication settingID={item.setting_id} g={getGlobalCommunicationSettings} h={getSchoolCommunicationSettings} isOpen={true}/>))
    }

    const handleDisable=(e,item)=>{
        setModal(false, ()=>setModal(<DisableCommunication settingID={item.setting_id} g={getGlobalCommunicationSettings} h={getSchoolCommunicationSettings} isOpen={true}/>))
    }


    return (
        <AppContainer title="Communication Settings">
            <Toaster position="top-center" reverseOrder={false} />
            {modal}
            <div className="row">
                

                <div className="col-lg-4">
                    <AddSetting g={getGlobalCommunicationSettings} h={getSchoolCommunicationSettings}/>
                </div>

                <div className="col-lg-8">
                    <div className="card custom-card" style={{borderRadius: "10px"}}>
                        <div className="card-body map-card">
                            <div class="heading-layout1 mg-b-25">
                                <TableHeader
                                title="Communication Settings"
                                subtitle="List of all the communication settings"
                                />
                                <div class="dropdown">
                                <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
                                </div>
                                </div>
                            </div>
                                        
                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                <Row>
                                <Col sm={12}>
                                <Nav variant="pills" className="flex-row mb-1">
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="first">
                                        Global Settings{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="second">
                                    School Settings{" "}
                                    </Nav.Link>
                                </Nav.Item>
                               
                                </Nav>
                            </Col>

                            <Col sm={12}>
                                <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                            <Loader /> 
                                        ) : (
                                        <CommunicationSettingsTable settingList={globalCommunicationSettings} handleEnable={handleEnable}  handleDisable={handleDisable} scopeType="global"/>
                                        )}
                            
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="second">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                                <Loader /> 
                                            ) : (
                                            <CommunicationSettingsTable settingList={schoolCommunicationSettings} handleEnable={handleEnable} handleDisable={handleDisable} scopeType="school"/>
                                        )}
                                    </div>

                                </Tab.Pane>

                                
                                </Tab.Content>
                            </Col>
                            </Row>
                            </Tab.Container>                
                                                        
                        </div>
                    </div>
                </div>
            </div>
        </AppContainer>
    );
}

export default CommunicationSettingsPage;
